var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mycard-select-card"},[_c('div',{staticClass:"card-title"},[_vm._v("\n\t\t"+_vm._s(_vm.customer.name)+"\n\t")]),_vm._v(" "),(_vm.$notEmpty(_vm.customer.nick_name))?_c('div',{staticClass:"text-muted"},[_vm._v("\n\t\t"+_vm._s(_vm.customer.nick_name)+"\n\t")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }